// #73: Wiedereinstieg in den Import-Wizard nach dem Wegnavigieren — nur in diesem Tab
// (sessionStorage). Der Server hält den Entwurf; hier steht nur, wo der Nutzer stand.
// Jeder Zugriff ist abgesichert: sessionStorage kann werfen (Privatmodus, gesperrte Cookies)
// oder leer sein; die Oberfläche muss dann ohne Wiedereinstieg funktionieren.

export type ResumableStep = 'classify' | 'mapping' | 'users' | 'preview';

export interface ResumeEntry {
  jobId: string;
  step: ResumableStep;
}

const STEPS: readonly string[] = ['classify', 'mapping', 'users', 'preview'];

const key = (projectId: string) => `testflow.import.resume.${projectId}`;

export function saveResume(projectId: string, entry: ResumeEntry): void {
  try {
    sessionStorage.setItem(key(projectId), JSON.stringify(entry));
  } catch {
    // kein Storage: kein Wiedereinstieg, kein Fehler
  }
}

export function loadResume(projectId: string): ResumeEntry | null {
  try {
    const raw = sessionStorage.getItem(key(projectId));
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      typeof (parsed as ResumeEntry).jobId === 'string' &&
      (parsed as ResumeEntry).jobId !== '' &&
      STEPS.includes((parsed as ResumeEntry).step)
    ) {
      const { jobId, step } = parsed as ResumeEntry;
      return { jobId, step };
    }
    return null;
  } catch {
    return null;
  }
}

export function clearResume(projectId: string): void {
  try {
    sessionStorage.removeItem(key(projectId));
  } catch {
    // siehe oben
  }
}
